export default __webpack_public_path__ + "static/media/Ascher@1x.79ee9a11.png";